export default __webpack_public_path__ + "static/media/price-new-3.b3b615a1.png";